import { render } from "./RegistrationView.vue?vue&type=template&id=7a3bfef3&ts=true"
import script from "./registration-view-component.ts?vue&type=script&lang=ts&external"
export * from "./registration-view-component.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__